import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconCrop24 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M5.24219 17.5161H15.25V19.0161H6.74219C5.91376 19.0161 5.24219 18.3445 5.24219 17.5161Z"
      fill="currentColor"
    />
    <path
      d="M6.74219 19.0161V2.75855C6.74219 2.34433 6.4064 2.00854 5.99219 2.00854C5.57797 2.00854 5.24219 2.34433 5.24219 2.75854V17.5161C5.24219 18.3445 5.91376 19.0161 6.74219 19.0161Z"
      fill="currentColor"
    />
    <path
      d="M5.24219 17.5161H6.74219V19.0161C5.91376 19.0161 5.24219 18.3445 5.24219 17.5161Z"
      fill="currentColor"
    />
    <path
      d="M2.24414 6.02319C2.24414 5.60898 2.57993 5.27319 2.99414 5.27319H5.24219V6.77319H2.99414C2.57993 6.77319 2.24414 6.4374 2.24414 6.02319Z"
      fill="currentColor"
    />
    <path
      d="M18.7559 6.48267H8.74805V4.98267H17.2559C18.0843 4.98267 18.7559 5.65424 18.7559 6.48267Z"
      fill="currentColor"
    />
    <path
      d="M17.2559 4.98267V21.2402C17.2559 21.6544 17.5916 21.9902 18.0059 21.9902C18.4201 21.9902 18.7559 21.6544 18.7559 21.2402V6.48267C18.7559 5.65424 18.0843 4.98267 17.2559 4.98267Z"
      fill="currentColor"
    />
    <path
      d="M18.7559 6.48267H17.2559V4.98267C18.0843 4.98267 18.7559 5.65424 18.7559 6.48267Z"
      fill="currentColor"
    />
    <path
      d="M21.7539 17.9756C21.7539 18.3898 21.4181 18.7256 21.0039 18.7256H18.7559V17.2256H21.0039C21.4181 17.2256 21.7539 17.5614 21.7539 17.9756Z"
      fill="currentColor"
    />
  </SvgIcon>
));
IconCrop24.displayName = 'IconCrop24';
